/** @jsx h */
import { h } from 'preact'

import Details from '../Details'
import IconDown from '../../../../assets/images/svgs/icon-chevron-down.svg'
import t from '../../../utils/translate'

const ImgIcon = ({ iconSvg }) =>
  <div dangerouslySetInnerHTML={{ __html: iconSvg }} />

const ThemeSection = ({ name, iconSvg, description, themesList, analyticsContext }) => {
  return (
    <section class='ModalCardV1-section--theme'>
      <Details
        className='DetailsV1'
        analyticsContext={analyticsContext}
        analyticsName='themeDetails'
        analyticsSubject={name}
        analyticsVersion={1}
      >
        <summary class='SummaryV1'>
          <div class={`SummaryV1-title Theme--${name.toLowerCase()}`}>
            <ImgIcon iconSvg={iconSvg} />
            <p>{name}</p>
          </div>
          <IconDown className='chevron' />
        </summary>
        <div class='DetailsV1-description'>
          {description}
        </div>
        <a href='/framework' target='_blank' class='Details--explore Action--arrow'>
          {t('proof_points.js.themes.explore')}
        </a>
        <div class='Details--icons'>
          {themesList && themesList.map((theme) =>
            <labelled-theme
              active={theme.name === name}
              aria-label={theme.name}
              dangerouslySetInnerHTML={{ __html: theme.iconSvg + theme.name }}
              key={theme.name}
              role='img'
            />
          )}
        </div>
      </Details>
    </section>
  )
}

export default ThemeSection
